export default __webpack_public_path__ + "static/media/hht1_home_img_EP9.ae1d3a53.png";